export default "__VITE_ASSET__CidJMEy0__"